import { create, StateCreator } from 'zustand';
import { DisplayStyle } from 'components/common/ToggleView/ToggleView';
import { initialFiltersState } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

interface Props {
    filterData: typeof initialFiltersState;
    setFilterData: (value: any) => void;

    displayStyle: DisplayStyle;
    setDisplayStyle: (value: DisplayStyle) => void;

    widgetFiltersData: IFilter[];
    setWidgetFiltersData: (value: IFilter[]) => void;
}
const state: StateCreator<Props> = (set) => ({
    filterData: initialFiltersState,
    setFilterData: (value) => set({ filterData: value }),

    displayStyle: DisplayStyle.ROWS,
    setDisplayStyle: (value) => set({ displayStyle: value }),

    widgetFiltersData: [],
    setWidgetFiltersData: (value) => set({ widgetFiltersData: value }),
});

export const useBattleCardsStore = create(state);
